import React, { Suspense } from 'react'
import { SupportContentContainer } from './styledComponents'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import { Route, Routes } from 'react-router'
import { supportRoutes } from './routes'

export default function SupportRoutesHandler({ isShowingSidebar }) {
  return (
    <SupportContentContainer removeLeftMargins={!isShowingSidebar}>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          {supportRoutes?.map(({ path, fullPath, name, Element, exact, ...props }, idx) => {
            return (
              Element &&
              (path === '' ? (
                <Route key={idx} index name={name} element={<Element {...props} />} />
              ) : (
                <Route key={idx} path={path} name={name} element={<Element {...props} />} />
              ))
            )
          })}
        </Routes>
      </Suspense>
    </SupportContentContainer>
  )
}
